import { render } from "./vendas_customizado.vue?vue&type=template&id=5092c18e"
import script from "./vendas_customizado.vue?vue&type=script&lang=js"
export * from "./vendas_customizado.vue?vue&type=script&lang=js"

import exportComponent from "D:\\DealDesk\\Homologação\\Mult_Cliente\\front_mult_clint\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__